import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { LoadingButton as Button } from '../LoadingButton/LoadingButton' 
import Container from '../../shared/container/Container'
import { MFA } from '../MFASteps'
import { trackEventMessage } from '../../../TelemetryService'
import { EventModel } from '../../../models/EventModel'
import { MFA_SETUP_EMAIL } from '../../../constants'

const MFAEmailEnrollment = ( { onClose, email, onHandleClick, onGoBackClick, webId } ) => {
    
    const headerReference = useRef( null )

const onHandleClose = ( ) => {
    trackEventMessage( new EventModel( MFA_SETUP_EMAIL.CLOSE, webId ) )
    onClose()
}

const onClick = async ( event ) => {
    event.preventDefault()
    trackEventMessage( new EventModel( MFA_SETUP_EMAIL.SEND_CODE, webId ) )
    onHandleClick( MFA.FACTORS.EMAIL )
}

const handleGoBack = async ( event ) => {
    event.preventDefault()
    trackEventMessage( new EventModel( MFA_SETUP_EMAIL.GO_BACK, webId ) )
    onGoBackClick()
}
    
useEffect( () => {
    headerReference?.current?.focus() 
}, [] 
)

  return ( <Container onClose={ onHandleClose } onCloseButtonId='dt-mfa-emailsetup-close'>                 
      <div className='mb-6'><header ref={ headerReference } tabIndex='0' className='c-mfa-label--title' aria-label={ MFA.EmailEnrollment.title }>{ MFA.EmailEnrollment.title }</header></div>                
      <div className='mb-6'>
          <div><label tabIndex='0' className='c-mfa-label--content' aria-label={ MFA.EmailEnrollment.text } data-testid="lbl-text">{ `${ MFA.EmailEnrollment.text } ` }</label></div>
          <div className='wrap-text'><label tabIndex='0' className='c-mfa-label--content c-mfa-phone-number' aria-label={ email }>{ email }</label></div>
      </div> 
      <div className='mb-7'>
          <Button id='dt-mfa-emailsetup-send-code' className={ 'c-btn c-btn--primary mb-5' } type="button" aria-label={ MFA.EmailEnrollment.buttonText + 'Enabled' } name={ MFA.EmailEnrollment.buttonText } onClick={ onClick } data-testid="btn-sendCode">{ MFA.EmailEnrollment.buttonText }</Button>
          <Button id='dt-mfa-emailsetup-go-back' className={ 'c-btn c-btn--tertiary mb-5' } onClick={ handleGoBack } aria-label={ `${ MFA.goBack } Enabled` } name={ MFA.goBack } type='button' data-testid="btn-GoBack">{ MFA.goBack }</Button>
      </div>
  </Container> 
  )
}

MFAEmailEnrollment.propTypes = {
    onClose: PropTypes.func.isRequired,
    onHandleClick: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    onGoBackClick: PropTypes.func.isRequired,
    webId: PropTypes.string
}

export default MFAEmailEnrollment
